import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ClearIcon from '@mui/icons-material/Clear';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, Stack, TextField } from '@mui/material';
import React from 'react';
import { useDataContext } from '../context/DataContext';
import { extractUrlFromText } from '../Utils';
import { useNavigate } from 'react-router';

interface AddBookmarkDialogProps {
  open: boolean;
  close: () => void;
}

export const AddBookmarkDialog: React.FC<AddBookmarkDialogProps> = (
  { open, close }
) => {

  const navigate = useNavigate();
  const isLocalhost = typeof window !== 'undefined' && window.location.host.startsWith('localhost');

  const { saveBookMark } = useDataContext();
  const [urlToSave, setUrlToSave] = React.useState('');

  React.useEffect(() => {
    (async () => {
      if (open) {
        const clipboardContents = await navigator.clipboard.readText();
        setUrlToSave('');
        if (clipboardContents) {
          const extractedUrl = extractUrlFromText(clipboardContents);
          if (extractedUrl) {
            setUrlToSave(extractedUrl);
          }
        }

      }
    })();
  }, [open]);

  return (
    <Dialog open={open} onClose={close} fullWidth>
      <Stack spacing={2}>
        <DialogTitle><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><AddCircleOutlineIcon color="secondary" /> Add bookmark</Box></DialogTitle>
        <DialogContent sx={{ overflow: 'visible' }}>
          <TextField label='URL' variant='outlined' size="small"
            fullWidth
            value={urlToSave}
            onChange={(event) => setUrlToSave(event.target.value)}
            InputProps={{
              endAdornment: (<InputAdornment position="end">
                <IconButton onClick={() => setUrlToSave('')}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>)
            }}
            onKeyUp={(event) => {
              if (event.key === 'Enter') {
                saveBookMark(urlToSave);
                close();
                navigate('/');
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={close}
            variant='outlined'>Cancel</Button>
          {isLocalhost && (
            <Button
              variant='outlined'
              disabled={!urlToSave}
              onClick={() => {
                close();
                navigate(`/share?text=${encodeURIComponent(urlToSave)}`);
              }}
            >
              Simulate share
            </Button>
          )}
          <Button
            variant='contained' color='secondary'
            disabled={!urlToSave}
            onClick={
              () => {
                saveBookMark(urlToSave);
                close();
              }
            }>Save</Button>
        </DialogActions>
      </Stack>
    </Dialog>
  );
};
